import React, { Component, Fragment } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'

import { track } from 'utils/trackingUtils'

const StepRoute = ({ path, Component, onBack, onContinue, index, stepCount, history, name, onDone, segment }) => (
  <Route path={path} render={() =>
    <Component path={path} onBack={onBack} onContinue={onContinue} index={index} stepCount={stepCount} history={history} name={name} onDone={onDone} segment={segment} />
  }/>
)

const NAVIGATION_METHODS = Object.freeze({
  'FORWARDS': 'Continued',
  'BACKWARDS': 'Went Back',
  'SKIPPED': 'Skipped'
})

export default class FlowManager extends Component {

  constructor(props) {
    super(props)

    this.state = {
      currentStep: 0,
      steps: props.steps || [],
    }
  }

  pushToStepByIndex = (index) => {
    const { steps } = this.state
    const { history, baseUrl } = this.props

    steps[index] && history.push(baseUrl + steps[index].route)
  }

  onContinue = (index, isSkipped = false) => {
    const { onDone } = this.props

    const navigationMethod = isSkipped ?
      NAVIGATION_METHODS.SKIPPED :
      NAVIGATION_METHODS.FORWARDS

    this.trackNavigation(navigationMethod)

    this.isLast(index) ?
      onDone && onDone() :
      this.updateCurrentStep(index + 1)
  }

  onBack = (index) => {
    this.trackNavigation(NAVIGATION_METHODS.BACKWARDS)

    if (index > 0) {
      this.updateCurrentStep(index - 1)
    }
  }

  trackNavigation = (method) => {
    const { name, segment } = this.props
    const { currentStep, steps } = this.state

    track(`${name} Step - ${method}`, {
      route: steps[currentStep].route,
      segment: segment
    })
  }

  updateCurrentStep = (currentStep) => {
    this.setState({ currentStep })
    this.pushToStepByIndex(currentStep)
  }

  isLast = (index) => index === this.state.steps.length - 1

  render() {
    const { steps } = this.state
    const { baseUrl, history, name, onDone, stepTotal=0, stepOffset=0, segment } = this.props
    return (
      <Fragment>
        <Switch>
          { steps.map((step, index) => (
            <StepRoute key={`route-${index}`}
              path={baseUrl + step.route}
              Component={step.component}
              onContinue={() => this.onContinue(index)}
              onBack={() => this.onBack(index)}
              onDone={onDone}
              index={stepOffset + index}
              stepCount={stepTotal + steps.length}
              history={history}
              segment={segment}
              name={name}/>
          ))}
          <Route render={() => <Redirect to={baseUrl + steps[0].route} />} />
        </Switch>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/FlowManager/index.js